// extracted by mini-css-extract-plugin
export default {"spinner":"loader__spinner__aflbr","load":"loader__load__gIxs7","heart":"loader__heart__RlAqs","whiteCircle":"loader__whiteCircle__VJcti","container":"loader__container__fpBSa"};